import { useState, useEffect } from 'react';

interface Notification {
  show: boolean;
  message: string;
  type: 'success' | 'error' | 'warning' | 'info';
}

export function useNotification() {
  const [notification, setNotification] = useState<Notification>({
    show: false,
    message: '',
    type: 'info',
  });

  const showNotification = (message: string, type: Notification['type'] = 'info') => {
    setNotification({
      show: true,
      message,
      type,
    });
  };

  const hideNotification = () => {
    setNotification((prev) => ({ ...prev, show: false }));
  };

  useEffect(() => {
    if (notification.show) {
      const timer = setTimeout(() => {
        hideNotification();
      }, 5000);
      return () => clearTimeout(timer);
    }
  }, [notification.show]);

  return {
    notification,
    showNotification,
    hideNotification,
  };
}
